import DepartmentGroupService from 'src/app/shared/services/department-group.service';
import { Component, EventEmitter, Input, inject } from '@angular/core';
import { Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SnackbarService } from 'ok-angular-shared/components';
import { catchError, finalize, of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { TopLoaderService } from 'src/app/core/services/top-loader.service';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { DepartmentGroup } from '../../departmentGroup.model';
import { ErrorMessage } from 'src/app/shared/models/errorMessage.model';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'adm-department-group-list',
  templateUrl: './department-group-list.component.html',
  styleUrl: './department-group-list.component.scss',
  imports: [MatTableModule, MatIconModule, MatButtonModule],
})
export class DepartmentGroupListComponent {
  private dialog = inject(MatDialog);
  private snackbarService = inject(SnackbarService);
  private departmentGroupService = inject(DepartmentGroupService);
  private loader = inject(TopLoaderService);

  @Input() departmentGroups: DepartmentGroup[];
  @Input() editMode: boolean;

  @Output() updateDepartmentGroup = new EventEmitter<DepartmentGroup>();
  @Output() update = new EventEmitter();

  deletedSuccessfullyText = 'Afdelingsgruppen blev slettet!';

  delete(index: number) {
    const departmentGroup = this.departmentGroups[index];
    const confirmDialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Slet afdelingsgruppe',
        text: `Er du sikker på at du vil slette afdelingsgruppen ${departmentGroup.name}?`,
        confirmText: 'Slet',
        denyText: 'Luk',
      },
      disableClose: true,
    });

    confirmDialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.loader.setLoading(true);
        this.departmentGroupService
          .deleteDepartmentGroup(departmentGroup.id)
          .pipe(
            catchError((httpError: HttpErrorResponse) => {
              if (httpError.status == 404 && httpError.error) {
                const error = httpError.error as ErrorMessage;
                if (error.code === 100160) {
                  this.snackbarService.warning('Afdelingsgruppen kunne ikke findes.');
                }
              } else if (httpError.status == 400 && httpError.error) {
                const error = httpError.error as ErrorMessage;
                if (error.code === 100161) {
                  this.snackbarService.warning('Kan ikke slette afdelingsgrupper med afdelinger under sig.');
                }
              } else {
                this.snackbarService.error('Der skete en fejl under sletning af afdelingsgruppe.');
              }
              return of();
            }),
            finalize(() => this.loader.setLoading(false))
          )
          .subscribe(() => {
            this.departmentGroups.splice(index, 1);
            this.snackbarService.success(this.deletedSuccessfullyText);
            this.update.emit();
          });
      }
    });
  }

  edit(index: number) {
    const updateDepartmentGroup = this.departmentGroups[index];

    if (updateDepartmentGroup) {
      // Emit the object to be updated
      this.updateDepartmentGroup.emit(updateDepartmentGroup);

      // Remove the connector from the list
      this.departmentGroups.splice(index, 1);
    }
  }
}
